import EmpresaService from "@/services/EmpresaService"
import { router } from '@/router'

export const actions = {
    cadastrarEmpresa: ({commit, dispatch}) => {
        commit('setEmpresa', {}),
        router.push({name: 'empresaCadastro'})
    },
    listarEmpresa: ({commit}, data) => {
        commit('setOverlay', true)
        EmpresaService.listar(data)
        .then(res => {
            commit('setEmpresas', res.data)
            commit('setOverlay', false)

        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    async visualizarEmpresa ({commit}, id) {
        commit('setOverlay', true)
        await EmpresaService.editar(id)
        .then(res => {
            commit('setEmpresa', res.data)
            commit('setOverlay', false)
        })
        .catch(e => {
            console.log(e)
        })
    },
    visualizarPaginaListarEmpresa: () => {
        router.push({name: 'empresas'})  
    },
    salvarEmpresa: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        EmpresaService.salvar(data)
        .then(res => {
            commit('setEmpresa', res.data)
            commit('addEmpresa', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Registro cadastrado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrado.')
        })
    },
    atualizarEmpresa: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        EmpresaService.atualizar(data)
        .then(res => {
            dispatch('listarEmpresa')
            commit('setOverlay', false)
            commit('snackbarInfo', 'Registro atualizado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirEmpresa: ({commit, dispatch}, data) => {
        dispatch('setModalExcluirEmpresa', false)
        dispatch('setModalCadastroEmpresa', false)
        commit('setOverlay', true)
        EmpresaService.excluir(data.id)
        .then(res => {
            commit('removeEmpresa', res.data)
            commit('setOverlay', false)
            commit('snackbarError', 'Registro excluído.')
        })
        .catch(e => {
            commit('snackbarError', 'Erro ao atualizar cliente.')
        })
    },
    setModalCadastroEmpresa: ({commit}, status) => {
        commit('setModalCadastrarEmpresa', false)
        setTimeout(() => {
            commit('setModalCadastrarEmpresa', status)
        }, 100);
    },
    setModalExcluirEmpresa: ({commit}, status) => {
        commit('setModalExcluirEmpresa', false)
        setTimeout(() => {
            commit('setModalExcluirEmpresa', status)
        }, 100);
    },
}

export default {}